import React, { useState, useEffect } from 'react';
import Spline from '@splinetool/react-spline';
import { ArrowRight, Shield, Zap } from 'lucide-react';

const HeroSection = () => {
  // Estado para detectar si el hardware es limitado (móvil o tablet)
  const [isLowPerformance, setIsLowPerformance] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      // Consideramos "baja potencia" si es móvil o si la pantalla es menor a 1024px
      setIsLowPerformance(window.innerWidth < 1024 || isMobile);
    };
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      padding: '80px 7.6923% 60px',
      background: '#000000',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '60px',
        alignItems: 'center',
        maxWidth: '1400px',
        margin: '0 auto',
        width: '100%',
        zIndex: 2
      }} className="hero-grid">
        {/* Left Content */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '32px'
        }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            background: 'rgba(0, 255, 209, 0.1)',
            borderRadius: '0px',
            width: 'fit-content'
          }}>
            <Shield size={18} color="#00FFD1" />
            <span style={{
              color: '#00FFD1',
              fontSize: '14px',
              fontWeight: 500
            }}>Infraestructura Segura</span>
          </div>

          <h1 style={{
            fontSize: '66px',
            fontWeight: 600,
            lineHeight: 1.1,
            letterSpacing: '-0.62px',
            color: '#FFFFFF',
            margin: 0
          }} className="hero-title">
            Soluciones Linux para el Futuro Digital
          </h1>

          <p style={{
            fontSize: '20px',
            fontWeight: 400,
            lineHeight: 1.5,
            color: 'rgba(255, 255, 255, 0.85)',
            maxWidth: '600px'
          }}>
            Plataforma avanzada de recuperación de desastres, auditoría de seguridad y optimización de redes para infraestructuras híbridas.
          </p>

          <div style={{
            display: 'flex',
            gap: '16px',
            flexWrap: 'wrap'
          }}>
            <button className="btn-primary" onClick={scrollToContact} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              Comenzar Ahora
              <ArrowRight size={20} />
            </button>
            <button className="btn-secondary" onClick={() => {
              const element = document.getElementById('products');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}>
              Ver Productos
            </button>
          </div>

          {/* Stats */}
          <div style={{
            display: 'flex',
            gap: '40px',
            marginTop: '20px'
          }} className="hero-stats">
            <div>
              <div style={{
                fontSize: '32px',
                fontWeight: 600,
                color: '#00FFD1'
              }}>99.9%</div>
              <div style={{
                fontSize: '14px',
                color: '#4D4D4D'
              }}>Disponibilidad</div>
            </div>
            <div>
              <div style={{
                fontSize: '32px',
                fontWeight: 600,
                color: '#00FFD1'
              }}>&lt;5ms</div>
              <div style={{
                fontSize: '14px',
                color: '#4D4D4D'
              }}>Latencia</div>
            </div>
            <div>
              <div style={{
                fontSize: '32px',
                fontWeight: 600,
                color: '#00FFD1'
              }}>24/7</div>
              <div style={{
                fontSize: '14px',
                color: '#4D4D4D'
              }}>Soporte</div>
            </div>
          </div>
        </div>

        {/* Right - 3D Spline Optimizado */}
        <div style={{
          width: '100%',
          height: '700px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'visible',
          position: 'relative'
        }} className="hero-spline">

          {!isLowPerformance ? (
            // Solo carga Spline si NO es móvil/tablet
            <Spline
              scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode"
              style={{
                width: '100%',
                height: '100%'
              }}
            />
          ) : (
            // Resplandor ligero para móviles (0% carga de CPU)
            <div style={{
              width: '100%',
              height: '100%',
              background: 'radial-gradient(circle, rgba(0, 255, 209, 0.12) 0%, transparent 70%)',
              borderRadius: '50%',
              filter: 'blur(40px)',
              animation: 'pulse 4s infinite ease-in-out'
            }} />
          )}
        </div>
      </div>

      <style jsx="true">{`
        @keyframes pulse {
          0%, 100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.05); }
        }
        @media (max-width: 1024px) {
          .hero-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
          .hero-title {
            font-size: 48px !important;
          }
          .hero-spline {
            height: 500px !important;
          }
        }
        @media (max-width: 767px) {
          .hero-title {
            font-size: 36px !important;
          }
          .hero-stats {
            flex-direction: column !important;
            gap: 20px !important;
          }
          .hero-spline {
            height: 400px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default HeroSection;

